// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] || chunkId) + "-" + {"218":"e1dccc2846805fc2de9f","270":"f534da8c54ebf63b3680","674":"bc9afd684b7bb4ad613f","691":"707bcbc6bc727f93011d"}[chunkId] + ".js";
};